import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './Body.module.scss';

const Body = ({ children, className, ...other }) => {
  return (
    <tbody className={cn(classes.base, className)} {...other}>
      {children}
    </tbody>
  );
};

Body.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default Body;
